export default __webpack_public_path__ + "static/media/SWT0540.34I-20596_-22456_0.08cdd00c.jpg";